/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation SmppCreateMutation(
  $displayName: String!,
  $ip: IPv4!,
  $username: String!,
  $password: String!,
  $sessionTimeoutInterval: Float!,
  $sessionAllowed: Int,
  $tps: Int,
  $enquireLinkInterval: Float!,
  $trunkType: TRUNK_TYPE!,
  $debuggingLevel: SMPP_DEBUGGING_LEVEL!
) {
  SmppCreate(
    displayName: $displayName,
    ip: $ip,
    username: $username,
    password: $password,
    sessionTimeoutInterval: $sessionTimeoutInterval,
    sessionAllowed: $sessionAllowed,
    tps: $tps,
    enquireLinkInterval: $enquireLinkInterval,
    trunkType: $trunkType,
    debuggingLevel: $debuggingLevel
  ) {
    id
    message
    status
  }
}
`
